import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { Box, Button, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import DialogBaseCC from 'components/Dialog/DialogBaseCC';
import { useTranslation } from 'react-i18next';
import { setCloseDialogCC } from 'utils/helpers';
import { ReactComponent as ProvideServiceImage } from '../../assets/svg/ProvideService.svg';
import { DIALOG_ID } from './constant';

const DialogProvideService = () => {
    const {t} = useTranslation();
    const propsDialog = useLegacyDialogProps();
    const { isLogin } = propsDialog

    return (
        <DialogBaseCC id={DIALOG_ID.PROVIDE_SERVICE} title={t('dialog.provide-service.title')}>
            <DialogContent sx={{ maxWidth: '100% !important' }}>
                <DialogContentText sx={{ maxWidth: '100% !important', display: 'flex', flexDirection: 'column'}}>
                    <Box>{t('dialog.provide-service.content-1')} <span style={{fontWeight: '700'}}>24h</span> {t('dialog.provide-service.content-2')}</Box>
                    {
                        isLogin &&
                        <Box>{t('dialog.provide-service.content-3')}</Box>
                    }
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '10px 0'}}>
                        <ProvideServiceImage/>
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={setCloseDialogCC}>{t('dialog.provide-service.button-second')}</Button>
                <Button onClick={() => {}}>{
                    isLogin 
                    ?
                    t('dialog.provide-service.button-login-primary')
                    :
                    t('dialog.provide-service.button-primary')
                }</Button>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogProvideService
